import a from './37.png';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';

function ImgOverlayExample() {
  return (
    <div className='contenedor-trabajos'>
      <h1 className='titulos'>Obras realizadas</h1>
      <div className='sub-contenedor-trabajos'>
        <button className='btn-trabajos1'>Obras de confort</button>
        <button className='btn-trabajos'>Obras de precisión</button>
      </div>
      <dir className="contenedor-tarjetas-trabajos">
      <Swiper
      // install Swiper modules
      modules={[Navigation]}
      spaceBetween={0}
      slidesPerView={1}
      navigation
      pagination={{ clickable: true }}
      onSwiper={(swiper) => console.log(swiper)}
      onSlideChange={() => console.log('slide change')}
    >
      <SwiperSlide className='displayf' >
        <div >
          <h1 className='titulo-card-cliente'>Hotel Marriott Plaza</h1>
          <img className='img-card' src={a}  alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide className='displayf' >
        <div  >
          <h1 className='titulo-card-cliente'>Hotel Marriott Plaza</h1>
          <img className='img-card' src={a}  alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide className='displayf' >
        <div  >
          <h1 className='titulo-card-cliente'>Hotel Marriott Plaza</h1>
          <img className='img-card' src={a}  alt="" />
        </div>
      </SwiperSlide>
      <SwiperSlide className='displayf' >
        <div  >
          <h1 className='titulo-card-cliente'>Hotel Marriott Plaza</h1>
          <img className='img-card' src={a}  alt="" />
        </div>
      </SwiperSlide>
      
    
      ...
    </Swiper>
      
      
      
      </dir>

    </div>
    
  );
}

export default ImgOverlayExample;